import { GameState, BuildingType, InputState } from '../types';
import { TILE, MAP_COLS, MAP_ROWS } from '../constants';
import { BUILDING_DEFS } from '../data/buildings';
import { isCellOccupied } from '../entities/building';
import { spawnBuildParticles } from '../particles';
import { playBuildSound } from '../audio';

export function updateBuildMode(state: GameState, input: InputState): void {
  if (!state.buildMode) return;

  // Update ghost position to player's facing grid cell
  const gridX = Math.floor(state.player.x / TILE);
  const gridY = Math.floor(state.player.y / TILE);

  // Offset by facing direction
  let gx = gridX, gy = gridY;
  switch (state.player.facing) {
    case 'up': gy -= 1; break;
    case 'down': gy += 1; break;
    case 'left': gx -= 1; break;
    case 'right': gx += 1; break;
  }

  // Clamp to map
  gx = Math.max(0, Math.min(gx, MAP_COLS - 1));
  gy = Math.max(0, Math.min(gy, MAP_ROWS - 1));

  state.buildGhostX = gx;
  state.buildGhostY = gy;
}

export function tryPlaceBuilding(state: GameState): boolean {
  if (!state.buildMode || !state.buildSelection) return false;

  const gx = state.buildGhostX;
  const gy = state.buildGhostY;

  // Check if cell is free
  if (isCellOccupied(gx, gy, state.buildings)) return false;

  // Check not on vendor or station
  if (gx === state.vendorX && gy === state.vendorY) return false;
  if (gx === state.stationGridX && gy === state.stationGridY) return false;

  // Check not on a tree
  for (const t of state.trees) {
    if (t.gridX === gx && t.gridY === gy) return false;
  }

  // Check player can afford it
  const def = BUILDING_DEFS.find(d => d.type === state.buildSelection);
  if (!def) return false;
  if (state.player.wood < def.woodCost || state.player.coins < def.coinCost) return false;

  // Deduct resources
  state.player.wood -= def.woodCost;
  state.player.coins -= def.coinCost;

  // Place building
  state.buildings.push({
    gridX: gx,
    gridY: gy,
    type: state.buildSelection,
  });

  // Effects
  spawnBuildParticles(gx * TILE + TILE / 2, gy * TILE + TILE / 2);
  playBuildSound();

  return true;
}
